import { Avatar } from "@heroui/react";
import { formatUnits } from "viem";

export function ClaimInfoCard({
  amount,
  tokenDecimals,
  tokenSymbol,
}: {
  amount: bigint;
  tokenDecimals: number;
  tokenSymbol: string;
}) {
  const displayAmount = formatUnits(amount, tokenDecimals);

  return (
    <div className="flex items-center gap-4 py-4 px-8 w-full rounded-large bg-[#3F6784]">
      <Avatar name={tokenSymbol} color="primary" classNames={{ base: "!size-8" }} />
      <div className="text-start">
        <div className="text-large font-semibold">
          {displayAmount} {tokenSymbol}
        </div>
        <div className="text-small font-normal text-[#AEC4D3]">Aztec Network</div>
      </div>
    </div>
  );
}
